"use client";

import { Button } from "@/components/rac/button";
import { getOtpMethodDisplayName, type OtpMethod } from "@/info/login";
import { MessageCircle, MessageSquare } from "lucide-react";

interface OtpMethodSelectorProps {
	selectedMethod: OtpMethod;
	onMethodChange: (method: OtpMethod) => void;
	isDisabled?: boolean;
	countryCode?: string;
}

export function OtpMethodSelector({
	selectedMethod,
	onMethodChange,
	isDisabled = false,
	countryCode = "IN",
}: OtpMethodSelectorProps) {
	const methods: OtpMethod[] = ["sms", "whatsapp"];

	return (
		<div className="space-y-2 mb-4">
			<label className="text-sm font-medium text-gray-700">
				{countryCode !== "IN" ? "Send OTP via WhatsApp (SMS not available for international users):" : "Send OTP via:"}
			</label>
			<div className="flex gap-2">
				{methods.map(method => {
					const isSelected = selectedMethod === method;
					const displayName = getOtpMethodDisplayName(method);
					const Icon = method === "whatsapp" ? MessageCircle : MessageSquare;

					return (
						<Button
							key={method}
							className={`flex-1 h-12 px-4 border transition-all duration-200 touch-manipulation`}
							onPress={() => onMethodChange(method)}
							isDisabled={isDisabled || (method === "sms" && countryCode !== "IN")}
							variant={isSelected ? "accent" : "ghost"}
						>
							<div className="flex items-center gap-2">
								<Icon className="w-4 h-4" />
								<span className="text-sm font-medium">{displayName}</span>
							</div>
						</Button>
					);
				})}
			</div>
		</div>
	);
}
